import { Suspense } from "react";

import { Skeleton } from "@stacklet/ui";
import { graphql, useLazyLoadQuery } from "react-relay";

import { NotificationsSettingsPage } from "../../settings/components/NotificationsSettingsPage";
import { UpsertNotificationRuleStepsContainer } from "../components/UpsertNotificationRuleStepsContainer";
import { NotificationRuleFormContextProvider } from "../contexts/NotificationRuleFormContext";
import { useNotificationRuleHelpContent } from "../hooks/useNotificationRuleHelpContent";
import { CreateNotificationRuleHeader } from "./CreateNotificationRuleHeader";

import type { CreateNotificationRuleRootQuery } from "./__generated__/CreateNotificationRuleRootQuery.graphql";

export function CreateNotificationRuleRoot() {
  const data = useLazyLoadQuery<CreateNotificationRuleRootQuery>(
    graphql`
      query CreateNotificationRuleRootQuery {
        ...CreateNotificationRuleHeader_query
        ...NotificationsSettingsPage_query
      }
    `,
    {},
  );
  const helpContent = useNotificationRuleHelpContent();

  return (
    <NotificationsSettingsPage
      helpContent={helpContent}
      queryRef={data}
      title="Create Notification Rule"
      withHeader={false}
    >
      <>
        <CreateNotificationRuleHeader queryRef={data} />
        <Suspense
          fallback={
            <Skeleton
              aria-label="Loading form…"
              className="mt-lg"
              height="24rem"
              variant="rectangular"
            />
          }
        >
          <NotificationRuleFormContextProvider isEditMode={false}>
            <UpsertNotificationRuleStepsContainer />
          </NotificationRuleFormContextProvider>
        </Suspense>
      </>
    </NotificationsSettingsPage>
  );
}
